import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
  import { useToken } from '@/useToken';
  import { useUser } from '@/useUser';
  
export default /*#__PURE__*/_defineComponent({
  __name: 'TaskGroupsPage',
  props: {
    verificationToken: { type: String, required: true },
    apiRoot: { type: String, required: true }
  },
  setup(__props: any) {

const props = __props as {
    verificationToken: string,
    apiRoot: string
  };

  

  const { token } = useToken();
  const { user } = useUser();
  const grid = ref<HTMLTmTaskGridElement | null>(null);

  watch([grid, user], ([newGrid, newUser]) => {
    if (newGrid === null || newUser === null) return;

    newGrid.currentUser = newUser;
  });

return { __sfc: true,props, token, user, grid }
}

})